import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProductCard from "../components/ProductCard";
import { DroppingSoonGrid } from "../components/DroppingSoonGrid";
import { api } from "../lib/api";

const SHOP_SPANS = [
  "md:col-span-6 lg:col-span-7",
  "md:col-span-6 lg:col-span-5",
  "md:col-span-6 lg:col-span-5",
  "md:col-span-6 lg:col-span-7",
];

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [comingSoon, setComingSoon] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/products"), api.get("/coming-soon")])
      .then(([p, c]) => {
        setProducts(p.data);
        setComingSoon(c.data.filter((x) => x.category === "F1"));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Header />
      <section className="border-b border-white/10 bg-black/40">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-12 md:pt-28">
          <p className="af-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
            // The Garage
          </p>
          <h1
            className="af-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.92]"
            data-testid="shop-title"
          >
            Shop frames
          </h1>
          <p className="text-zinc-400 mt-6 max-w-2xl">
            Each frame is engineered with collector-grade detail. Display-ready
            on arrival, with custom stand included.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        {loading && (
          <p className="af-mono text-zinc-500 text-sm" data-testid="shop-loading">
            Loading garage…
          </p>
        )}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {products
            .filter((p) => (p.category || "f1") !== "fortnite")
            .map((p, i) => (
              <ProductCard
                key={p.slug}
                product={p}
                span={SHOP_SPANS[i % SHOP_SPANS.length]}
              />
            ))}
        </div>
        <DroppingSoonGrid items={comingSoon} accent="#FF2800" />
      </section>
      <Footer />
    </div>
  );
}
